// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"8d7f3a60","494":"5db8d099","623":"f05ffe8c"}[chunkId] + ".chunk.js");